import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img width={1340} src={require('../../Images/errorPage.jpg')} alt="" />
        </div>
    );
};

export default NotFound;